import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TitleSetterService } from '../core/services';

const routes = [
  {
    path: '/about',
    title: 'Who is Bill Chaser?',
  },
  {
    path: '/how-it-works',
    title: 'How it works',
  },
  {
    path: '/pricing',
    title: 'Pricing',
  },
  {
    path: '/faq',
    title: 'FAQ',
  },
  {
    path: '/contact',
    title: 'Contact',
  },
];

@Component({
  templateUrl: './layout.component.html',
})
export class LayoutComponent {

  showMenu: boolean;

  // @HostListener('window:scroll', [])
  // onScroll() {
  //   if (this.homeStats.nativeElement.getBoundingClientRect().top < this.breakpoint) {
  //     this.homeStats.nativeElement.classList.add('scrolled-into');
  //     this.onScroll = function(){};
  //   }
  // }

  constructor(
    private router: Router,
    private titleSetter: TitleSetterService,
  ) {}

  ngOnInit() {
    this.titleSetter.initialise(routes);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.showMenu = false);
  }
}



// WEBPACK FOOTER //
// ./src/app/marketing/layout.component.ts